import DefaultModal from "components/Common/Modal/DefaultModal";
import ModalButton from "components/Common/Modal/ModalButton";
import React from "react";
import { useNavigate } from "react-router-dom";

const IBSTestModal = ({ modalClose }: { modalClose: () => void }) => {
  const navigate = useNavigate();

  return (
    <DefaultModal
      title="IBS 자가진단이 아직 완료되지 않았어요"
      content={`병원 현황 파악을 위해 IBS 진단이 필요합니다.\n지금 측정해보세요.`}
      handlModalClose={modalClose}
      state="error"
      button={
        <ModalButton
          buttonType="two"
          confirmButtonText="IBS 검사하기"
          handleConfirm={() => {
            navigate("/mypage/ibs");
            modalClose();
          }}
          handleCancel={modalClose}
        />
      }
    />
  );
};

export default IBSTestModal;
